import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import {Navbar, Nav, DropdownButton, MenuItem, Breadcrumb } from 'react-bootstrap';

import history from './../../../../../src/config/history';

import routesCollection from 'config/routes';

import SpogLink from 'router-with/ui/SpogLinkRoute';

import SpogButton from 'components/ui/form/SpogButton';

import {debounce, getMatchRoute} from 'util/utils';

import 'style/components/ui/layout/nav/subnavigation.scss';


/** Subnavigation component for the second level of routes/menu */
class Subnavigation extends Component {

    static propTypes = {
        intl:      PropTypes.object.isRequired, // The i18n object
        routes:    PropTypes.array.isRequired, //The routes to show
        path:      PropTypes.string.isRequired, // The current selected path
        extra:     PropTypes.any, // Extra content to show inside subnavigation at rightside
        onRefresh: PropTypes.func // Listener when refresh button was clicked
    };

    handleRefresh(refresh) {
        const DELAY = 500;

        return debounce(() => {
            const {onRefresh} = this.props;

            onRefresh(refresh);
        }, DELAY);
    }

    isSameUrl(url) {
        const {path} = this.props;

        return !!~path.indexOf(url);
    }

    renderLinks() {
        const {routes} = this.props;

        return routes && routes.map(route => this.renderLink(`/${route.path}`, route.name, route.path, route.sup));
    }

    renderLink(url, name, key, sup) {
        const {intl:{formatMessage}} = this.props;

        const renderSup = () => {
            if (sup) {
                return <sup>{sup}</sup>;
            }

            return null;
        };

        return (
            <MenuItem
                key={key}
                active={this.isSameUrl(url)}
                eventKey={key}
            >
                <SpogLink to={url} >
                    {formatMessage({id: name})} {renderSup()}
                </SpogLink>
            </MenuItem>
        );
    }

    renderExtra() {
        const {extra} = this.props;

        return extra ?
            <Nav className="subnavigation-extra" pullRight>
                {extra}
            </Nav>
            : null;
    }

    renderDropdown() {
        const {intl:{formatMessage}, routes} = this.props;
        const filteredElementArray = routes.find(tab => this.isSameUrl(tab.path));
        const title = filteredElementArray ? formatMessage({id: filteredElementArray.name}) : '';

        return (
            <DropdownButton
                id="subnavigation-nav"
                className="subnavigation-nav"
                title={title}
            >
                {this.renderLinks()}
            </DropdownButton>
        );
    }

    renderRefresh() {
        const {path} = this.props;
        const matchRoute = getMatchRoute(routesCollection, path);

        return matchRoute.refresh ?
            <SpogButton
                key="refresh"
                className="refresh-button"
                icon="refresh"
                onClick={this.handleRefresh(matchRoute.refresh)}
            /> : null;
    }

    handleOnClick = () => {
        history.push('/cloud/');
    }

    render() {
        const {routes, extra, intl:{formatMessage}} = this.props;
        const filterRoutes = routes.filter(r => r.clave === 'cloud');

        if (routes[0].clave) {
            return (
                <Fragment>
                    <Breadcrumb extra={extra} style={{ backgroundColor: 'white' }}>
                        <Breadcrumb.Item onClick={this.handleOnClick} style={{ color: '#ED1C24' }}>Cloud</Breadcrumb.Item>
                        <Breadcrumb.Item active>{filterRoutes.map(
                            route => formatMessage({id: route.breadcrumb})
                        )}</Breadcrumb.Item>
                    </Breadcrumb>
                    <Navbar className="subnavigation">
                        <Navbar.Header>
                            <Navbar.Toggle />
                        </Navbar.Header>
                        <Navbar className="subnavigation-menu">
                            {this.renderDropdown()}
                            {this.renderRefresh()}
                        </Navbar>
                        {this.renderExtra()}
                    </Navbar>
                </Fragment>
            );
        }

        return (
            <Navbar className="subnavigation">
                <Navbar.Header>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar className="subnavigation-menu">
                    {this.renderDropdown()}
                    {this.renderRefresh()}
                </Navbar>
                {this.renderExtra()}
            </Navbar>
        );
    }
}

export default injectIntl(Subnavigation);



// WEBPACK FOOTER //
// ./src/components/ui/layout/nav/Subnavigation.jsx